import { Dashboard } from './Dashboard'
import Heading from './Heading'

Dashboard.Heading = Heading

export { Dashboard, Heading }
